export const getEmptyFieldsModalText = (type: string, isSave: boolean) => {
    switch (type) {
        case 'isSomeLastOrderDateEmpty':
            return `Календарь не может быть утвержден, так как не по всем магазинам
                указаны даты в ячейках "Дата получения последнего заказа".`

        case 'isSomeFirstOrderDateEmpty':
            return `Календарь не может быть утвержден, так как не по всем магазинам
                указаны даты в ячейках "Дата получения первого заказа".`

        case 'isSomeDeliveryDateEmpty':
            return `Календарь не может быть утвержден. 
            Не заполнена дата доставки в дни недоступности`

        case 'isOrderDatesIsEmpty':
            return `Календарь не может быть утвержден. 
            Есть заполненные поля в дни недоступности, но пустые в датах получения 
            первого или последнего заказов`

        case 'isAllDateEmpty':
            return 'Календарь не может быть утвержден, так как ни по одному магазину не указаны даты.'

        default:
            return `
                Вы не заполнили даты по одному или нескольким магазинам.
                Вы уверены, что хотите ${isSave ? 'сохранить' : 'утвердить'} 
                календарь?
            `
    }
}
